'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

var _providersFormlyApiCheck = require('./providers/formlyApiCheck');

var _providersFormlyApiCheck2 = _interopRequireDefault(_providersFormlyApiCheck);

var _otherDocsBaseUrl = require('./other/docsBaseUrl');

var _otherDocsBaseUrl2 = _interopRequireDefault(_otherDocsBaseUrl);

var _providersFormlyUsability = require('./providers/formlyUsability');

var _providersFormlyUsability2 = _interopRequireDefault(_providersFormlyUsability);

var _providersFormlyConfig = require('./providers/formlyConfig');

var _providersFormlyConfig2 = _interopRequireDefault(_providersFormlyConfig);

var _providersFormlyValidationMessages = require('./providers/formlyValidationMessages');

var _providersFormlyValidationMessages2 = _interopRequireDefault(_providersFormlyValidationMessages);

var _servicesFormlyUtil = require('./services/formlyUtil');

var _servicesFormlyUtil2 = _interopRequireDefault(_servicesFormlyUtil);

var _servicesFormlyWarn = require('./services/formlyWarn');

var _servicesFormlyWarn2 = _interopRequireDefault(_servicesFormlyWarn);

var _directivesFormlyCustomValidation = require('./directives/formly-custom-validation');

var _directivesFormlyCustomValidation2 = _interopRequireDefault(_directivesFormlyCustomValidation);

var _directivesFormlyField = require('./directives/formly-field');

var _directivesFormlyField2 = _interopRequireDefault(_directivesFormlyField);

var _directivesFormlyFocus = require('./directives/formly-focus');

var _directivesFormlyFocus2 = _interopRequireDefault(_directivesFormlyFocus);

var _directivesFormlyForm = require('./directives/formly-form');

var _directivesFormlyForm2 = _interopRequireDefault(_directivesFormlyForm);

var _runFormlyNgModelAttrsManipulator = require('./run/formlyNgModelAttrsManipulator');

var _runFormlyNgModelAttrsManipulator2 = _interopRequireDefault(_runFormlyNgModelAttrsManipulator);

var _runFormlyCustomTags = require('./run/formlyCustomTags');

var _runFormlyCustomTags2 = _interopRequireDefault(_runFormlyCustomTags);

var ngModuleName = 'formly';

exports['default'] = ngModuleName;

var ngModule = _angularFix2['default'].module(ngModuleName, []);

ngModule.constant('formlyApiCheck', _providersFormlyApiCheck2['default']);
ngModule.constant('formlyErrorAndWarningsUrlPrefix', _otherDocsBaseUrl2['default']);
ngModule.constant('formlyVersion', VERSION); // <-- webpack variable

ngModule.provider('formlyUsability', _providersFormlyUsability2['default']);
ngModule.provider('formlyConfig', _providersFormlyConfig2['default']);

ngModule.factory('formlyValidationMessages', _providersFormlyValidationMessages2['default']);
ngModule.factory('formlyUtil', _servicesFormlyUtil2['default']);
ngModule.factory('formlyWarn', _servicesFormlyWarn2['default']);

ngModule.directive('formlyCustomValidation', _directivesFormlyCustomValidation2['default']);
ngModule.directive('formlyField', _directivesFormlyField2['default']);
ngModule.directive('formlyFocus', _directivesFormlyFocus2['default']);
ngModule.directive('formlyForm', _directivesFormlyForm2['default']);

ngModule.run(_runFormlyNgModelAttrsManipulator2['default']);
ngModule.run(_runFormlyCustomTags2['default']);
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./index.common.js
 **/